
"use strict";

// =====================================================
// usuario
//
// Archivo:
// src/fronend/seguridad/usuario/usuario.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosusuarios = [];

let empleadosUsuarios = [];

let empleadoSeleccionadoUsuario = null;

let usuarioSeleccionadoEditar = null;

let usuarioSeleccionadoEliminar = null;


// =====================================================
// ELEMENTOS
// =====================================================

const tablaUsuarios =
    document.getElementById("tbodyUsuarios");

const btnNuevoUsuario =
    document.getElementById("btnNuevoUsuario");

const btnGuardarUsuario =
    document.getElementById("btnGuardarUsuario");

const btnActualizarUsuario =
    document.getElementById("btnActualizarUsuario");

const btnConfirmarEliminarUsuario =
    document.getElementById("btnConfirmarEliminarUsuario");

const modalUsuario =
    document.getElementById("modalUsuario");

const modalEditarUsuario =
    document.getElementById("modalEditarUsuario");

const modalEliminarUsuario =
    document.getElementById("modalEliminarUsuario");


// =====================================================
// INICIALIZAR MODULO
// =====================================================

document.addEventListener("DOMContentLoaded", () => {

    listarUsuarios();

    listarEmpleadosUsuarios();

    configurarEventos();

});


// =====================================================
// CONFIGURAR EVENTOS
// =====================================================

function configurarEventos() {


    // =================================================
    // BOTÓN CREAR USUARIO
    // =================================================

    if (btnNuevoUsuario) {

        btnNuevoUsuario.addEventListener(
            "click",
            abrirModalCrearUsuario
        );

    }


    // =================================================
    // BOTÓN GUARDAR USUARIO
    // =================================================

    if (btnGuardarUsuario) {

        btnGuardarUsuario.addEventListener(
            "click",
            guardarUsuario
        );

    }


    // =================================================
    // BOTÓN ACTUALIZAR USUARIO
    // =================================================

    if (btnActualizarUsuario) {

        btnActualizarUsuario.addEventListener(
            "click",
            actualizarUsuario
        );

    }


    // =================================================
    // BOTÓN CONFIRMAR ELIMINAR
    // =================================================

    if (btnConfirmarEliminarUsuario) {

        btnConfirmarEliminarUsuario.addEventListener(
            "click",
            eliminarUsuario
        );

    }


    // =================================================
    // DROPDOWN EMPLEADO CREAR
    // =================================================

    const selectEmpleado =
        document.getElementById(
            "idEmpleadoUsuario"
        );


    if (selectEmpleado) {

        selectEmpleado.addEventListener(
            "change",
            seleccionarEmpleadoUsuario
        );

    }


    // =================================================
    // DROPDOWN EMPLEADO EDITAR
    // =================================================

    const selectEmpleadoEditar =
        document.getElementById(
            "idEmpleadoEditarUsuario"
        );


    if (selectEmpleadoEditar) {

        selectEmpleadoEditar.addEventListener(
            "change",
            seleccionarEmpleadoEditarUsuario
        );

    }


    // =================================================
    // BÚSQUEDA
    // =================================================

    const buscarUsuario =
        document.getElementById(
            "buscarUsuario"
        );


    if (buscarUsuario) {

        buscarUsuario.addEventListener(
            "input",
            filtrarUsuarios
        );

    }


    // =================================================
    // LIMPIAR BÚSQUEDA
    // =================================================

    const btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            limpiarBusqueda
        );

    }

}


// =====================================================
// LISTAR USUARIOS
// =====================================================
//
// URL:
// GET /usuario/listar
//
// =====================================================

async function listarUsuarios() {

    try {

        const respuesta =
            await fetch(
                "/usuario/listar"
            );


        if (!respuesta.ok) {

            throw new Error(
                "No se pudo obtener la información de usuarios"
            );

        }


        const resultado =
            await respuesta.json();


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "Error al listar usuarios"
            );

        }


        registrosusuarios =
            resultado.data || [];


        llenarTablaUsuarios();

        actualizarResumenUsuarios();


    } catch (error) {

        console.error(
            "Error al cargar usuarios:",
            error
        );


        if (tablaUsuarios) {

            tablaUsuarios.innerHTML = `
                <tr>
                    <td
                        colspan="8"
                        class="text-center text-danger p-4"
                    >
                        <i class="bi bi-exclamation-triangle me-2"></i>
                        Error al cargar los usuarios
                    </td>
                </tr>
            `;

        }

    }

}


// =====================================================
// LISTAR EMPLEADOS PARA DROPDOWN
// =====================================================
//
// URL:
// GET /usuario/listarusuarioss
//
// =====================================================

async function listarEmpleadosUsuarios() {

    try {

        const respuesta =
            await fetch(
                "/usuario/listarusuarioss"
            );


        if (!respuesta.ok) {

            throw new Error(
                "No se pudo obtener la lista de empleados"
            );

        }


        const resultado =
            await respuesta.json();


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "Error al listar empleados"
            );

        }


        empleadosUsuarios =
            resultado.data || [];


        llenarDropdownEmpleados();

        llenarDropdownEmpleadosEditar();


    } catch (error) {

        console.error(
            "Error al cargar empleados para usuarios:",
            error
        );


        const selectEmpleado =
            document.getElementById(
                "idEmpleadoUsuario"
            );


        if (selectEmpleado) {

            selectEmpleado.innerHTML = `
                <option value="">
                    Error al cargar empleados
                </option>
            `;

        }


        const selectEmpleadoEditar =
            document.getElementById(
                "idEmpleadoEditarUsuario"
            );


        if (selectEmpleadoEditar) {

            selectEmpleadoEditar.innerHTML = `
                <option value="">
                    Error al cargar empleados
                </option>
            `;

        }

    }

}


// =====================================================
// LLENAR DROPDOWN CREAR
// =====================================================

function llenarDropdownEmpleados() {

    const selectEmpleado =
        document.getElementById(
            "idEmpleadoUsuario"
        );


    if (!selectEmpleado) {

        console.warn(
            "No se encontró #idEmpleadoUsuario"
        );

        return;

    }


    selectEmpleado.innerHTML = "";


    const opcionInicial =
        document.createElement("option");


    opcionInicial.value = "";

    opcionInicial.textContent =
        "Seleccione un empleado";

    opcionInicial.selected = true;


    selectEmpleado.appendChild(
        opcionInicial
    );


    empleadosUsuarios.forEach(
        empleado => {

            const opcion =
                document.createElement(
                    "option"
                );


            opcion.value =
                empleado.IDEMPLEADO;

            opcion.textContent =
                empleado.NOMBREEMPLEADO;


            selectEmpleado.appendChild(
                opcion
            );

        }
    );

}


// =====================================================
// LLENAR DROPDOWN EDITAR
// =====================================================

function llenarDropdownEmpleadosEditar() {

    const selectEmpleado =
        document.getElementById(
            "idEmpleadoEditarUsuario"
        );


    if (!selectEmpleado) {

        return;

    }


    selectEmpleado.innerHTML = "";


    const opcionInicial =
        document.createElement("option");


    opcionInicial.value = "";

    opcionInicial.textContent =
        "Seleccione un empleado";


    selectEmpleado.appendChild(
        opcionInicial
    );


    empleadosUsuarios.forEach(
        empleado => {

            const opcion =
                document.createElement(
                    "option"
                );


            opcion.value =
                empleado.IDEMPLEADO;

            opcion.textContent =
                empleado.NOMBREEMPLEADO;


            selectEmpleado.appendChild(
                opcion
            );

        }
    );

}


// =====================================================
// SELECCIONAR EMPLEADO CREAR
// =====================================================

function seleccionarEmpleadoUsuario(event) {

    const idEmpleado =
        event.target.value;


    if (!idEmpleado) {

        empleadoSeleccionadoUsuario =
            null;


        limpiarDatosEmpleadoUsuario();

        return;

    }


    empleadoSeleccionadoUsuario =
        empleadosUsuarios.find(
            empleado =>
                String(
                    empleado.IDEMPLEADO
                ) ===
                String(
                    idEmpleado
                )
        );


    if (!empleadoSeleccionadoUsuario) {

        limpiarDatosEmpleadoUsuario();

        return;

    }


    mostrarDatosEmpleadoUsuario(
        empleadoSeleccionadoUsuario
    );

}


// =====================================================
// SELECCIONAR EMPLEADO EDITAR
// =====================================================

function seleccionarEmpleadoEditarUsuario(event) {

    const idEmpleado =
        event.target.value;


    if (!idEmpleado) {

        limpiarDatosEmpleadoEditarUsuario();

        return;

    }


    const empleado =
        empleadosUsuarios.find(
            item =>
                String(
                    item.IDEMPLEADO
                ) ===
                String(
                    idEmpleado
                )
        );


    if (!empleado) {

        limpiarDatosEmpleadoEditarUsuario();

        return;

    }


    mostrarDatosEmpleadoEditarUsuario(
        empleado
    );

}


// =====================================================
// MOSTRAR DATOS EMPLEADO CREAR
// =====================================================

function mostrarDatosEmpleadoUsuario(
    empleado
) {

    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleadoUsuario"
        );


    const nombreEmpleado =
        document.getElementById(
            "nombreEmpleadoUsuario"
        );


    const dpiEmpleado =
        document.getElementById(
            "dpiEmpleadoUsuario"
        );


    const direccionEmpleado =
        document.getElementById(
            "direccionEmpleadoUsuario"
        );


    if (mostrarIdEmpleado) {

        mostrarIdEmpleado.value =
            empleado.IDEMPLEADO ?? "";

    }


    if (nombreEmpleado) {

        nombreEmpleado.value =
            empleado.NOMBREEMPLEADO ?? "";

    }


    if (dpiEmpleado) {

        dpiEmpleado.value =
            empleado.DPI ?? "";

    }


    if (direccionEmpleado) {

        direccionEmpleado.value =
            empleado.DIRECCION ?? "";

    }

}


// =====================================================
// MOSTRAR DATOS EMPLEADO EDITAR
// =====================================================

function mostrarDatosEmpleadoEditarUsuario(
    empleado
) {

    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleadoEditarUsuario"
        );


    const nombreEmpleado =
        document.getElementById(
            "nombreEmpleadoEditarUsuario"
        );


    const dpiEmpleado =
        document.getElementById(
            "dpiEmpleadoEditarUsuario"
        );


    const direccionEmpleado =
        document.getElementById(
            "direccionEmpleadoEditarUsuario"
        );


    if (mostrarIdEmpleado) {

        mostrarIdEmpleado.value =
            empleado.IDEMPLEADO ?? "";

    }


    if (nombreEmpleado) {

        nombreEmpleado.value =
            empleado.NOMBREEMPLEADO ?? "";

    }


    if (dpiEmpleado) {

        dpiEmpleado.value =
            empleado.DPI ?? "";

    }


    if (direccionEmpleado) {

        direccionEmpleado.value =
            empleado.DIRECCION ?? "";

    }

}


// =====================================================
// LIMPIAR DATOS EMPLEADO CREAR
// =====================================================

function limpiarDatosEmpleadoUsuario() {

    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleadoUsuario"
        );


    const nombreEmpleado =
        document.getElementById(
            "nombreEmpleadoUsuario"
        );


    const dpiEmpleado =
        document.getElementById(
            "dpiEmpleadoUsuario"
        );


    const direccionEmpleado =
        document.getElementById(
            "direccionEmpleadoUsuario"
        );


    if (mostrarIdEmpleado) {

        mostrarIdEmpleado.value = "";

    }


    if (nombreEmpleado) {

        nombreEmpleado.value = "";

    }


    if (dpiEmpleado) {

        dpiEmpleado.value = "";

    }


    if (direccionEmpleado) {

        direccionEmpleado.value = "";

    }

}


// =====================================================
// LIMPIAR DATOS EMPLEADO EDITAR
// =====================================================

function limpiarDatosEmpleadoEditarUsuario() {

    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleadoEditarUsuario"
        );


    const nombreEmpleado =
        document.getElementById(
            "nombreEmpleadoEditarUsuario"
        );


    const dpiEmpleado =
        document.getElementById(
            "dpiEmpleadoEditarUsuario"
        );


    const direccionEmpleado =
        document.getElementById(
            "direccionEmpleadoEditarUsuario"
        );


    if (mostrarIdEmpleado) {

        mostrarIdEmpleado.value = "";

    }


    if (nombreEmpleado) {

        nombreEmpleado.value = "";

    }


    if (dpiEmpleado) {

        dpiEmpleado.value = "";

    }


    if (direccionEmpleado) {

        direccionEmpleado.value = "";

    }

}


// =====================================================
// LLENAR TABLA
// =====================================================

function llenarTablaUsuarios() {

    if (!tablaUsuarios) {

        return;

    }


    tablaUsuarios.innerHTML = "";


    if (registrosusuarios.length === 0) {

        tablaUsuarios.innerHTML = `
            <tr>
                <td
                    colspan="8"
                    class="text-center p-4"
                >
                    No hay usuarios registrados
                </td>
            </tr>
        `;

        return;

    }


    registrosusuarios.forEach(
        usuario => {

            const fila =
                document.createElement(
                    "tr"
                );


            fila.innerHTML = `

                <td>
                    ${usuario.IDUSUARIO ?? ""}
                </td>

                <td>
                    ${usuario.NOMBREEMPLEADO ?? ""}
                </td>

                <td>
                    ${usuario.DPI ?? ""}
                </td>

                <td>
                    ${usuario.DIRECCION ?? ""}
                </td>

                <td>
                    ${usuario.NOMBRE_USUARIO ?? ""}
                </td>

                <td>
                    ${formatearFecha(
                        usuario.FECHAREGISTRO
                    )}
                </td>

                <td>
                    ${
                        usuario.ESTADO === "A"
                            ?
                            `
                                <span class="badge-activo">
                                    Activo
                                </span>
                            `
                            :
                            `
                                <span class="badge-inactivo">
                                    Inactivo
                                </span>
                            `
                    }
                </td>

                <td>

                    <div class="d-flex gap-1">

                        <button
                            type="button"
                            class="btn btn-outline-primary btn-accion"
                            title="Editar usuario"
                            onclick="abrirModalEditarUsuario(${usuario.IDUSUARIO})">

                            <i class="bi bi-pencil-square"></i>

                        </button>


                        <button
                            type="button"
                            class="btn btn-outline-danger btn-accion"
                            title="Eliminar usuario"
                            onclick="abrirModalEliminarUsuario(${usuario.IDUSUARIO})">

                            <i class="bi bi-trash"></i>

                        </button>

                    </div>

                </td>

            `;


            tablaUsuarios.appendChild(
                fila
            );

        }
    );

}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumenUsuarios() {

    const totalUsuarios =
        document.getElementById(
            "totalUsuarios"
        );


    const totalUsuariosActivos =
        document.getElementById(
            "totalUsuariosActivos"
        );


    if (totalUsuarios) {

        totalUsuarios.textContent =
            registrosusuarios.length;

    }


    if (totalUsuariosActivos) {

        const activos =
            registrosusuarios.filter(
                usuario =>
                    usuario.ESTADO === "A"
            ).length;


        totalUsuariosActivos.textContent =
            activos;

    }

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFecha(fecha) {

    if (!fecha) {

        return "";

    }


    const fechaObj =
        new Date(fecha);


    if (
        isNaN(
            fechaObj.getTime()
        )
    ) {

        return fecha;

    }


    return fechaObj.toLocaleDateString(
        "es-GT",
        {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }
    );

}


// =====================================================
// ABRIR MODAL CREAR USUARIO
// =====================================================

function abrirModalCrearUsuario() {

    if (!modalUsuario) {

        console.warn(
            "No se encontró #modalUsuario"
        );

        return;

    }


    const formulario =
        document.getElementById(
            "formUsuario"
        );


    if (formulario) {

        formulario.reset();

    }


    empleadoSeleccionadoUsuario =
        null;


    limpiarDatosEmpleadoUsuario();


    if (
        empleadosUsuarios.length === 0
    ) {

        listarEmpleadosUsuarios();

    } else {

        llenarDropdownEmpleados();

    }


    const fechaRegistroUsuario =
        document.getElementById(
            "fechaRegistroUsuario"
        );


    if (fechaRegistroUsuario) {

        const hoy =
            new Date();


        const año =
            hoy.getFullYear();


        const mes =
            String(
                hoy.getMonth() + 1
            ).padStart(
                2,
                "0"
            );


        const dia =
            String(
                hoy.getDate()
            ).padStart(
                2,
                "0"
            );


        fechaRegistroUsuario.value =
            `${año}-${mes}-${dia}`;

    }


    const estadoUsuario =
        document.getElementById(
            "estadoUsuario"
        );


    if (estadoUsuario) {

        estadoUsuario.value =
            "A";

    }


    const titulo =
        document.getElementById(
            "tituloModalUsuario"
        );


    if (titulo) {

        titulo.innerHTML = `
            <i class="bi bi-person-plus-fill me-2"></i>
            Crear usuario
        `;

    }


    const instancia =
        bootstrap.Modal.getOrCreateInstance(
            modalUsuario
        );


    instancia.show();

}


// =====================================================
// GUARDAR USUARIO
// =====================================================

async function guardarUsuario() {

    try {

        const selectEmpleado =
            document.getElementById(
                "idEmpleadoUsuario"
            );


        const nombreUsuario =
            document.getElementById(
                "nombreUsuario"
            );


        const passwordUsuario =
            document.getElementById(
                "passwordUsuario"
            );


        const fechaRegistroUsuario =
            document.getElementById(
                "fechaRegistroUsuario"
            );


        const estadoUsuario =
            document.getElementById(
                "estadoUsuario"
            );


        if (!selectEmpleado) {

            throw new Error(
                "No se encontró el campo de empleado"
            );

        }


        if (!nombreUsuario) {

            throw new Error(
                "No se encontró el campo de nombre de usuario"
            );

        }


        if (!passwordUsuario) {

            throw new Error(
                "No se encontró el campo de contraseña"
            );

        }


        if (!fechaRegistroUsuario) {

            throw new Error(
                "No se encontró la fecha de registro"
            );

        }


        if (!estadoUsuario) {

            throw new Error(
                "No se encontró el estado"
            );

        }


        const idEmpleado =
            selectEmpleado.value;


        const nombreUsuarioValor =
            nombreUsuario.value.trim();


        const passwordValor =
            passwordUsuario.value.trim();


        const fechaRegistro =
            fechaRegistroUsuario.value;


        const estado =
            estadoUsuario.value;


        if (!idEmpleado) {

            alert(
                "Debe seleccionar un empleado."
            );

            selectEmpleado.focus();

            return;

        }


        if (!nombreUsuarioValor) {

            alert(
                "Debe ingresar el nombre de usuario."
            );

            nombreUsuario.focus();

            return;

        }


        if (!passwordValor) {

            alert(
                "Debe ingresar la contraseña."
            );

            passwordUsuario.focus();

            return;

        }


        if (!fechaRegistro) {

            alert(
                "Debe ingresar la fecha de registro."
            );

            fechaRegistroUsuario.focus();

            return;

        }


        if (!estado) {

            alert(
                "Debe seleccionar el estado."
            );

            estadoUsuario.focus();

            return;

        }


        if (btnGuardarUsuario) {

            btnGuardarUsuario.disabled =
                true;


            btnGuardarUsuario.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-1">
                </span>
                Guardando...
            `;

        }


        const datosUsuario = {

            nombreUsuario:
                nombreUsuarioValor,

            password:
                passwordValor,

            idEmpleado:
                Number(idEmpleado),

            fechaRegistro:
                fechaRegistro,

            estado:
                estado

        };


        console.log(
            "Datos enviados:",
            datosUsuario
        );


        const respuesta =
            await fetch(
                "/usuario/guardar",
                {

                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify(
                            datosUsuario
                        )

                }
            );


        const resultado =
            await respuesta.json();


        console.log(
            "Respuesta servidor:",
            resultado
        );


        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo guardar el usuario"
            );

        }


        alert(
            resultado.mensaje ||
            "Usuario guardado correctamente."
        );


        if (modalUsuario) {

            const instancia =
                bootstrap.Modal.getInstance(
                    modalUsuario
                );


            if (instancia) {

                instancia.hide();

            }

        }


        if (formularioExiste("formUsuario")) {

            document
                .getElementById("formUsuario")
                .reset();

        }


        empleadoSeleccionadoUsuario =
            null;


        limpiarDatosEmpleadoUsuario();


        await listarUsuarios();


    } catch (error) {

        console.error(
            "Error al guardar usuario:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al guardar el usuario."
        );


    } finally {

        if (btnGuardarUsuario) {

            btnGuardarUsuario.disabled =
                false;


            btnGuardarUsuario.innerHTML = `
                <i
                    class="bi bi-person-check-fill me-1">
                </i>
                Crear usuario
            `;

        }

    }

}


// =====================================================
// ABRIR MODAL EDITAR
// =====================================================

function abrirModalEditarUsuario(
    idUsuario
) {

    const usuario =
        registrosusuarios.find(
            item =>
                String(
                    item.IDUSUARIO
                ) ===
                String(
                    idUsuario
                )
        );


    if (!usuario) {

        alert(
            "No se encontró el usuario seleccionado."
        );

        return;

    }


    usuarioSeleccionadoEditar =
        usuario;


    if (!modalEditarUsuario) {

        console.warn(
            "No se encontró #modalEditarUsuario"
        );

        return;

    }


    // =================================================
    // ID USUARIO
    // =================================================

    const idUsuarioEditar =
        document.getElementById(
            "idUsuarioEditar"
        );


    if (idUsuarioEditar) {

        idUsuarioEditar.value =
            usuario.IDUSUARIO ?? "";

    }


    // =================================================
    // EMPLEADO
    // =================================================

    const selectEmpleado =
        document.getElementById(
            "idEmpleadoEditarUsuario"
        );


    if (selectEmpleado) {

        if (
            empleadosUsuarios.length === 0
        ) {

            llenarDropdownEmpleadosEditar();

        }


        /*
         * LISTARUSUARIO no muestra IDEMPLEADO.
         *
         * Por eso solamente se selecciona
         * automáticamente si el dato existe.
         */

        if (usuario.IDEMPLEADO) {

            selectEmpleado.value =
                usuario.IDEMPLEADO;

        } else {

            selectEmpleado.value =
                "";

        }

    }


    // =================================================
    // DATOS EMPLEADO
    // =================================================

    const empleado =
        empleadosUsuarios.find(
            item =>
                String(
                    item.IDEMPLEADO
                ) ===
                String(
                    usuario.IDEMPLEADO
                )
        );


    if (empleado) {

        mostrarDatosEmpleadoEditarUsuario(
            empleado
        );

    } else {

        const nombreEmpleado =
            document.getElementById(
                "nombreEmpleadoEditarUsuario"
            );


        const dpiEmpleado =
            document.getElementById(
                "dpiEmpleadoEditarUsuario"
            );


        const direccionEmpleado =
            document.getElementById(
                "direccionEmpleadoEditarUsuario"
            );


        if (nombreEmpleado) {

            nombreEmpleado.value =
                usuario.NOMBREEMPLEADO ?? "";

        }


        if (dpiEmpleado) {

            dpiEmpleado.value =
                usuario.DPI ?? "";

        }


        if (direccionEmpleado) {

            direccionEmpleado.value =
                usuario.DIRECCION ?? "";

        }

    }


    // =================================================
    // NOMBRE USUARIO
    // =================================================

    const nombreUsuario =
        document.getElementById(
            "nombreUsuarioEditar"
        );


    if (nombreUsuario) {

        nombreUsuario.value =
            usuario.NOMBRE_USUARIO ?? "";

    }


    // =================================================
    // PASSWORD
    // =================================================

    const passwordUsuario =
        document.getElementById(
            "passwordUsuarioEditar"
        );


    if (passwordUsuario) {

        passwordUsuario.value =
            usuario.PASSWORD ?? "";

    }


    // =================================================
    // FECHA
    // =================================================

    const fechaRegistro =
        document.getElementById(
            "fechaRegistroEditarUsuario"
        );


    if (fechaRegistro) {

        fechaRegistro.value =
            convertirFechaInput(
                usuario.FECHAREGISTRO
            );

    }


    // =================================================
    // ESTADO
    // =================================================

    const estadoUsuario =
        document.getElementById(
            "estadoEditarUsuario"
        );


    if (estadoUsuario) {

        estadoUsuario.value =
            usuario.ESTADO ?? "A";

    }


    // =================================================
    // TÍTULO
    // =================================================

    const titulo =
        document.getElementById(
            "tituloModalEditarUsuario"
        );


    if (titulo) {

        titulo.innerHTML = `
            <i class="bi bi-pencil-square me-2"></i>
            Editar usuario
        `;

    }


    // =================================================
    // MOSTRAR MODAL
    // =================================================

    const instancia =
        bootstrap.Modal.getOrCreateInstance(
            modalEditarUsuario
        );


    instancia.show();

}


// =====================================================
// ACTUALIZAR USUARIO
// =====================================================
//
// URL:
// PUT /usuario/editar
//
// Ejecuta:
// SP_USUARIO_U
//
// Parámetros enviados:
//
// @IDUSUARIO
// @NOMBRE_USUARIO
// @PASSWORD
// @FECHAREGISTRO
// @ESTADO
//
// NOTA:
// @IDEMPLEADO NO SE ENVÍA AL SP_USUARIO_U
// porque el procedimiento SQL no lo recibe.
//
// =====================================================

async function actualizarUsuario() {

    try {

        if (!usuarioSeleccionadoEditar) {

            alert(
                "No se ha seleccionado ningún usuario."
            );

            return;

        }


        // =================================================
        // ID USUARIO
        // =================================================

        const idUsuario =
            document.getElementById(
                "idUsuarioEditar"
            );


        // =================================================
        // EMPLEADO
        // =================================================
        //
        // Se mantiene el campo en el modal.
        // No se envía al procedimiento.
        //
        // =================================================

        const idEmpleado =
            document.getElementById(
                "idEmpleadoEditarUsuario"
            );


        // =================================================
        // NOMBRE USUARIO
        // =================================================

        const nombreUsuario =
            document.getElementById(
                "nombreUsuarioEditar"
            );


        // =================================================
        // PASSWORD
        // =================================================

        const passwordUsuario =
            document.getElementById(
                "passwordUsuarioEditar"
            );


        // =================================================
        // FECHA
        // =================================================

        const fechaRegistro =
            document.getElementById(
                "fechaRegistroEditarUsuario"
            );


        // =================================================
        // ESTADO
        // =================================================

        const estado =
            document.getElementById(
                "estadoEditarUsuario"
            );


        // =================================================
        // VALIDAR ELEMENTOS
        // =================================================

        if (!idUsuario) {

            throw new Error(
                "No se encontró el ID del usuario."
            );

        }


        if (!nombreUsuario) {

            throw new Error(
                "No se encontró el nombre de usuario."
            );

        }


        if (!passwordUsuario) {

            throw new Error(
                "No se encontró la contraseña."
            );

        }


        if (!fechaRegistro) {

            throw new Error(
                "No se encontró la fecha."
            );

        }


        if (!estado) {

            throw new Error(
                "No se encontró el estado."
            );

        }


        // =================================================
        // VALIDAR ID
        // =================================================

        if (!idUsuario.value) {

            alert(
                "No se encontró el ID del usuario."
            );

            return;

        }


        // =================================================
        // VALIDAR NOMBRE
        // =================================================

        if (!nombreUsuario.value.trim()) {

            alert(
                "Debe ingresar el nombre de usuario."
            );

            nombreUsuario.focus();

            return;

        }


        // =================================================
        // VALIDAR PASSWORD
        // =================================================

        if (!passwordUsuario.value.trim()) {

            alert(
                "Debe ingresar la contraseña."
            );

            passwordUsuario.focus();

            return;

        }


        // =================================================
        // VALIDAR FECHA
        // =================================================

        if (!fechaRegistro.value) {

            alert(
                "Debe ingresar la fecha de registro."
            );

            fechaRegistro.focus();

            return;

        }


        // =================================================
        // VALIDAR ESTADO
        // =================================================

        if (!estado.value) {

            alert(
                "Debe seleccionar el estado."
            );

            estado.focus();

            return;

        }


        // =================================================
        // DESHABILITAR BOTÓN
        // =================================================

        if (btnActualizarUsuario) {

            btnActualizarUsuario.disabled =
                true;


            btnActualizarUsuario.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-1">
                </span>
                Actualizando...
            `;

        }


        // =================================================
        // DATOS PARA SP_USUARIO_U
        // =================================================
        //
        // IMPORTANTE:
        // NO enviamos idEmpleado porque
        // SP_USUARIO_U no lo recibe.
        //
        // =================================================

        const datosUsuario = {

            idUsuario:
                Number(
                    idUsuario.value
                ),

            nombreUsuario:
                nombreUsuario.value.trim(),

            password:
                passwordUsuario.value.trim(),

            fechaRegistro:
                fechaRegistro.value,

            estado:
                estado.value

        };


        console.log(
            "Datos actualización:",
            datosUsuario
        );


        // =================================================
        // ENVIAR ACTUALIZACIÓN
        // =================================================
        //
        // URL CONSERVADA:
        // /usuario/editar
        //
        // =================================================

        const respuesta =
            await fetch(
                "/usuario/editar",
                {

                    method: "PUT",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify(
                            datosUsuario
                        )

                }
            );


        // =================================================
        // LEER RESPUESTA
        // =================================================

        const resultado =
            await respuesta.json();


        console.log(
            "Respuesta actualización:",
            resultado
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo actualizar el usuario."
            );

        }


        // =================================================
        // MENSAJE
        // =================================================

        alert(
            resultado.mensaje ||
            "Usuario actualizado correctamente."
        );


        // =================================================
        // CERRAR MODAL
        // =================================================

        if (modalEditarUsuario) {

            const instancia =
                bootstrap.Modal.getInstance(
                    modalEditarUsuario
                );


            if (instancia) {

                instancia.hide();

            }

        }


        // =================================================
        // LIMPIAR SELECCIÓN
        // =================================================

        usuarioSeleccionadoEditar =
            null;


        // =================================================
        // RECARGAR TABLA
        // =================================================

        await listarUsuarios();


    } catch (error) {

        console.error(
            "Error al actualizar usuario:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al actualizar el usuario."
        );


    } finally {

        // =================================================
        // RESTAURAR BOTÓN
        // =================================================

        if (btnActualizarUsuario) {

            btnActualizarUsuario.disabled =
                false;


            btnActualizarUsuario.innerHTML = `
                <i class="bi bi-check-circle me-1"></i>
                Actualizar usuario
            `;

        }

    }

}


// =====================================================
// ABRIR MODAL ELIMINAR
// =====================================================

function abrirModalEliminarUsuario(
    idUsuario
) {

    const usuario =
        registrosusuarios.find(
            item =>
                String(
                    item.IDUSUARIO
                ) ===
                String(
                    idUsuario
                )
        );


    if (!usuario) {

        alert(
            "No se encontró el usuario seleccionado."
        );

        return;

    }


    usuarioSeleccionadoEliminar =
        usuario;


    if (!modalEliminarUsuario) {

        console.warn(
            "No se encontró #modalEliminarUsuario"
        );

        return;

    }


    // =================================================
    // MOSTRAR DATOS
    // =================================================

    const idUsuarioEliminar =
        document.getElementById(
            "idUsuarioEliminar"
        );


    const nombreEmpleadoEliminar =
        document.getElementById(
            "nombreEmpleadoEliminarUsuario"
        );


    const nombreUsuarioEliminar =
        document.getElementById(
            "nombreUsuarioEliminar"
        );


    if (idUsuarioEliminar) {

        idUsuarioEliminar.value =
            usuario.IDUSUARIO ?? "";

    }


    if (nombreEmpleadoEliminar) {

        nombreEmpleadoEliminar.value =
            usuario.NOMBREEMPLEADO ?? "";

    }


    if (nombreUsuarioEliminar) {

        nombreUsuarioEliminar.value =
            usuario.NOMBRE_USUARIO ?? "";

    }


    // =================================================
    // MENSAJE
    // =================================================

    const mensaje =
        document.getElementById(
            "mensajeEliminarUsuario"
        );


    if (mensaje) {

        mensaje.innerHTML = `
            ¿Está seguro de que desea eliminar
            el usuario
            <strong>
                ${usuario.NOMBRE_USUARIO ?? ""}
            </strong>?
        `;

    }


    // =================================================
    // MOSTRAR MODAL
    // =================================================

    const instancia =
        bootstrap.Modal.getOrCreateInstance(
            modalEliminarUsuario
        );


    instancia.show();

}


// =====================================================
// ELIMINAR USUARIO
// =====================================================
//
// Se realiza eliminación lógica.
//
// URL:
// PUT /usuario/eliminar
//
// =====================================================

async function eliminarUsuario() {

    try {

        if (!usuarioSeleccionadoEliminar) {

            alert(
                "No se ha seleccionado ningún usuario."
            );

            return;

        }


        const idUsuario =
            usuarioSeleccionadoEliminar.IDUSUARIO;


        if (!idUsuario) {

            throw new Error(
                "No se encontró el ID del usuario."
            );

        }


        if (btnConfirmarEliminarUsuario) {

            btnConfirmarEliminarUsuario.disabled =
                true;


            btnConfirmarEliminarUsuario.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-1">
                </span>
                Eliminando...
            `;

        }


        const datosUsuario = {

            idUsuario:
                Number(
                    idUsuario
                ),

            estado:
                "I"

        };


        console.log(
            "Datos eliminación:",
            datosUsuario
        );


        const respuesta =
            await fetch(
                "/usuario/eliminar",
                {

                    method: "PUT",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify(
                            datosUsuario
                        )

                }
            );


        const resultado =
            await respuesta.json();


        console.log(
            "Respuesta eliminación:",
            resultado
        );


        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo eliminar el usuario."
            );

        }


        alert(
            resultado.mensaje ||
            "Usuario eliminado correctamente."
        );


        if (modalEliminarUsuario) {

            const instancia =
                bootstrap.Modal.getInstance(
                    modalEliminarUsuario
                );


            if (instancia) {

                instancia.hide();

            }

        }


        usuarioSeleccionadoEliminar =
            null;


        await listarUsuarios();


    } catch (error) {

        console.error(
            "Error al eliminar usuario:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al eliminar el usuario."
        );


    } finally {

        if (btnConfirmarEliminarUsuario) {

            btnConfirmarEliminarUsuario.disabled =
                false;


            btnConfirmarEliminarUsuario.innerHTML = `
                <i class="bi bi-trash me-1"></i>
                Eliminar usuario
            `;

        }

    }

}


// =====================================================
// BUSCAR USUARIOS
// =====================================================

function filtrarUsuarios() {

    const input =
        document.getElementById(
            "buscarUsuario"
        );


    if (!input) {

        return;

    }


    const texto =
        input.value
            .toLowerCase()
            .trim();


    if (!texto) {

        llenarTablaUsuarios();

        return;

    }


    const usuariosFiltrados =
        registrosusuarios.filter(
            usuario => {

                return (

                    String(
                        usuario.NOMBREEMPLEADO ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        usuario.DPI ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        usuario.NOMBRE_USUARIO ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                );

            }
        );


    llenarTablaUsuariosFiltrados(
        usuariosFiltrados
    );

}


// =====================================================
// TABLA FILTRADA
// =====================================================

function llenarTablaUsuariosFiltrados(
    usuarios
) {

    if (!tablaUsuarios) {

        return;

    }


    tablaUsuarios.innerHTML = "";


    if (usuarios.length === 0) {

        tablaUsuarios.innerHTML = `
            <tr>
                <td
                    colspan="8"
                    class="text-center p-4"
                >
                    No se encontraron usuarios.
                </td>
            </tr>
        `;

        return;

    }


    usuarios.forEach(
        usuario => {

            const fila =
                document.createElement(
                    "tr"
                );


            fila.innerHTML = `

                <td>
                    ${usuario.IDUSUARIO ?? ""}
                </td>

                <td>
                    ${usuario.NOMBREEMPLEADO ?? ""}
                </td>

                <td>
                    ${usuario.DPI ?? ""}
                </td>

                <td>
                    ${usuario.DIRECCION ?? ""}
                </td>

                <td>
                    ${usuario.NOMBRE_USUARIO ?? ""}
                </td>

                <td>
                    ${formatearFecha(
                        usuario.FECHAREGISTRO
                    )}
                </td>

                <td>
                    ${
                        usuario.ESTADO === "A"
                            ?
                            `
                                <span class="badge-activo">
                                    Activo
                                </span>
                            `
                            :
                            `
                                <span class="badge-inactivo">
                                    Inactivo
                                </span>
                            `
                    }
                </td>

                <td>

                    <div class="d-flex gap-1">

                        <button
                            type="button"
                            class="btn btn-outline-primary btn-accion"
                            title="Editar usuario"
                            onclick="abrirModalEditarUsuario(${usuario.IDUSUARIO})">

                            <i class="bi bi-pencil-square"></i>

                        </button>


                        <button
                            type="button"
                            class="btn btn-outline-danger btn-accion"
                            title="Eliminar usuario"
                            onclick="abrirModalEliminarUsuario(${usuario.IDUSUARIO})">

                            <i class="bi bi-trash"></i>

                        </button>

                    </div>

                </td>

            `;


            tablaUsuarios.appendChild(
                fila
            );

        }
    );

}


// =====================================================
// LIMPIAR BÚSQUEDA
// =====================================================

function limpiarBusqueda() {

    const buscarUsuario =
        document.getElementById(
            "buscarUsuario"
        );


    if (buscarUsuario) {

        buscarUsuario.value = "";

    }


    llenarTablaUsuarios();

}


// =====================================================
// RECARGAR TABLA
// =====================================================

async function recargarUsuarios() {

    await listarUsuarios();

}


// =====================================================
// CONVERTIR FECHA PARA INPUT DATE
// =====================================================

function convertirFechaInput(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const fechaObj =
        new Date(fecha);


    if (
        isNaN(
            fechaObj.getTime()
        )
    ) {

        return "";

    }


    const año =
        fechaObj.getFullYear();


    const mes =
        String(
            fechaObj.getMonth() + 1
        ).padStart(
            2,
            "0"
        );


    const dia =
        String(
            fechaObj.getDate()
        ).padStart(
            2,
            "0"
        );


    return `${año}-${mes}-${dia}`;

}


// =====================================================
// VALIDAR SI EXISTE ELEMENTO
// =====================================================

function formularioExiste(
    id
) {

    return Boolean(
        document.getElementById(id)
    );

}


// =====================================================
// EXPORTAR FUNCIONES
// =====================================================

window.listarUsuarios =
    listarUsuarios;


window.listarEmpleadosUsuarios =
    listarEmpleadosUsuarios;


window.recargarUsuarios =
    recargarUsuarios;


window.abrirModalCrearUsuario =
    abrirModalCrearUsuario;


window.guardarUsuario =
    guardarUsuario;


window.abrirModalEditarUsuario =
    abrirModalEditarUsuario;


window.actualizarUsuario =
    actualizarUsuario;


window.abrirModalEliminarUsuario =
    abrirModalEliminarUsuario;


window.eliminarUsuario =
    eliminarUsuario;
